import JournalSlider from './JournalSlider';
import JournalSliderContainer from './JournalSlider.container';

export default JournalSliderContainer(JournalSlider);
